module.exports = __webpack_public_path__ + "static/media/flagGood.1332aece.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Flags/flagGood.svg
// module id = 890
// module chunks = 0